import './paramount/style';
import FormStructure from './paramount/form_structure';

export default FormStructure;